// Boot-time validation for the Vite-injected env vars. Importing this module
// (see src/main.tsx) runs the parse at app startup so a malformed value fails
// loud — with a Zod error pointing at the bad key — rather than silently
// becoming `undefined` and degrading deep inside the app (e.g. a typo'd
// VITE_SUPABASE_URL would produce a null client and an unauth'd offline-only
// session with no diagnostic).
//
// All three vars are `.optional()`: the app is designed to run as a pure
// offline Dexie fork when Supabase isn't configured (CI without secrets,
// public forks, etc.), and the Sentry DSN is similarly optional. The point
// here isn't to require them — it's to require that, when present, they're
// well-formed.

import { z } from 'zod';

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url().optional(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1).optional(),
  // Sentry's DSN is a URL but the historical .env.example has shipped with an
  // empty string to mean "off"; accept both rather than forcing a delete.
  VITE_SENTRY_DSN: z.string().url().optional().or(z.literal('')),
});

export const env = envSchema.parse(import.meta.env);
